import * as CapitalMuiTheme_Theme_components_feedback_MuiAlert from "./MuiAlert.js";
import * as CapitalMuiTheme_Theme_components_feedback_MuiCircularProgress from "./MuiCircularProgress.js";
import * as CapitalMuiTheme_Theme_components_feedback_MuiDialog from "./MuiDialog.js";
import * as CapitalMuiTheme_Theme_components_feedback_MuiLinearProgress from "./MuiLinearProgress.js";
import * as CapitalMuiTheme_Theme_components_feedback_MuiSkeleton from "./MuiSkeleton.js";
import * as CapitalMuiTheme_Theme_components_feedback_MuiSnackbar from "./MuiSnackbar.js";
const feedback = {
  ...CapitalMuiTheme_Theme_components_feedback_MuiCircularProgress,
  ...CapitalMuiTheme_Theme_components_feedback_MuiLinearProgress,
  ...CapitalMuiTheme_Theme_components_feedback_MuiAlert,
  ...CapitalMuiTheme_Theme_components_feedback_MuiDialog,
  ...CapitalMuiTheme_Theme_components_feedback_MuiSkeleton,
  ...CapitalMuiTheme_Theme_components_feedback_MuiSnackbar
};
export {
  feedback
};
//# sourceMappingURL=index.js.map
